import { clsx } from 'clsx';
import { getConfidenceColor } from '@utils/formatters';

interface ConfidenceScoreProps {
  score: number | undefined;
  showPercentage?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const ConfidenceScore = ({
  score,
  showPercentage = true,
  size = 'md',
}: ConfidenceScoreProps) => {
  if (!score) {
    return <span className="text-gray-500">N/A</span>;
  }

  const color = getConfidenceColor(score);
  const normalizedScore = score <= 1 ? score * 100 : score;
  const percentage = Math.round(normalizedScore);

  const colorClasses: Record<string, string> = {
    green: 'bg-primary-100 dark:bg-primary-900 text-primary-800 dark:text-primary-100 border-primary-300 dark:border-primary-700',
    yellow: 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-100 border-yellow-300 dark:border-yellow-700',
    red: 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100 border-red-300 dark:border-red-700',
    gray: 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-100 border-gray-300 dark:border-gray-600',
  };

  const sizeClasses: Record<string, string> = {
    sm: 'px-2 py-1 text-xs rounded',
    md: 'px-3 py-1 text-sm rounded-md',
    lg: 'px-4 py-2 text-base rounded-lg',
  };

  return (
    <span className={clsx('inline-block font-semibold border', colorClasses[color] || colorClasses.gray, sizeClasses[size])}>
      {showPercentage ? `${percentage}%` : percentage}
    </span>
  );
};
